import { render, staticRenderFns } from "./PartnerPrices.vue?vue&type=template&id=6dfd8090"
import script from "./PartnerPrices.vue?vue&type=script&lang=js"
export * from "./PartnerPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports